// extracted by mini-css-extract-plugin
export var EventsBlock = "events-block-module--EventsBlock--14NYj";
export var EventsBlock__img = "events-block-module--EventsBlock__img--1ZHpm";
export var EventsBlock__title = "events-block-module--EventsBlock__title--11SFh";
export var EventsBlock__count = "events-block-module--EventsBlock__count--3g5r8";